export const usePrimeVue = () => {
    const tabHandler = (tabIndex, ...args: Function[]) => {
        args.forEach((func, i) => {
            if (tabIndex !== i) return;
            func();
        });
    };

    return {
        tabHandler,
    };
};
